import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseDeleteCashSettlementConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useDeleteCashSettlement({
  onSuccess,
  onReject,
}: UseDeleteCashSettlementConfigs) {
  const {
    execute: deleteCashSettlement,
    isPending: isLoadingDeleteCashSettlement,
    ...query
  } = useMutation(API.deleteCashSettlement, {
    onSuccess,
    onReject,
  });

  return { deleteCashSettlement, isLoadingDeleteCashSettlement, ...query };
}
